export const UPPERCASE_REGEX = /[A-Z]/;
export const LOWERCASE_REGEX = /[a-z]/;
export const NUMERALS_REGEX = /\d/;
export const SPECIAL_CHAR_REGEX = /[.!@#$%^&*()_+-=]/;
export const THREE_IDENTICAL_REGEX = /([a-zA-Z0-9])\1\1+/;
export const TRAILING_SPACES_REGEX = /^[ \s]+|[ \s]+$/;
